import { libraryGraphql } from "../config/library-graphql"

import * as TestComp1 from "../components/lib/test/sections/test-comp-1/TestComp1Section"
import * as TestComp2 from "../components/lib/test/sections/test-comp-2/TestComp2Section"
import * as RhHeaderHeroButtons from "../components/lib/rh/rh-header-hero-buttons/RhHeaderHeroButtonsSection.js"
import * as VideoPageCardSection from "../components/lib/common/sections/video-page-card-section/VideoPageCardSection"
import * as BigQuote from "../components/lib/common/sections/big-quote/BigQuoteSection"
import * as RhJobAdSearchFormSection from "../components/lib/rh/job-ad/rh-job-ad-search-form/RhJobAdSearchFormSection"
import * as CtxArticleHeaderSection from "../components/lib/common/sections/ctx-article-header/CtxArticleHeaderSection"
import * as CtxArticleViewerSection from "../components/lib/common/sections/ctx-article-viewer/CtxArticleViewerSection"
import * as RhJobSectorMosaic from "../components/lib/rh/section/rh-job-sector-mosaic/RhJobSectorMosaicSection"
import * as TitleTextButton from "../components/lib/common/sections/title-text-button-section/TitleTextButtonSection"
import * as RhCtxAgencyPresentation from "../components/lib/rh/rh-ctx-agency-presentation/RhCtxAgencyPresentationSection"
import * as RhJobAdLastBannersSection from "../components/lib/rh/job-ad/rh-job-ad-last-banners/RhJobAdLastBannersSection"
import * as RhCtxAgencyHeroSection from "../components/lib/rh/rh-ctx-agency-hero/RhCtxAgencyHeroSection"
import * as RhCtxAgencyMosaic from "../components/lib/rh/section/rh-ctx-agency-mosaic/RhCtxAgencyMosaicSection"
import * as CtxArticlesByTag from "../components/lib/blog/sections/ctx-articles-by-tag/CtxArticlesByTag"
import * as ArticleLeftRight from "../components/lib/blog/sections/article-left-right/ArticleLeftRightSection"
import * as CtxJobSectorPersons from "../components/lib/rh/ctx-job-sector-persons/CtxJobSectorPersons"
import * as BlogArticlesSelectionBannerSection from "../components/lib/blog/blog-articles-selection-banner/BlogArticlesSelectionBannerSection"
import * as BlogNewsletterSubscriptionSection from "../components/lib/blog/BlogNewsletterSubscriptionSection/BlogNewsletterSubscriptionSection"
import * as RhJobAdResultsSection from "../components/lib/rh/job-ad/rh-job-ad-results/RhJobAdResultsSection"
import * as HeroHeaderTagsListSection from "../components/lib/rh/header-hero-tags-list/HeroHeaderTagsListSection"
import * as CtxJobAdHeaderSection from "../components/lib/rh/context/job-ad/rh-ctx-job-ad-header/RhCtxJobAdHeaderSection"
import * as CtxJobAdViewerSection from "../components/lib/rh/context/job-ad/rh-ctx-job-ad-viewer/RhCtxJobAdViewerSection"
import * as ArticlesByTag from "../components/lib/blog/sections/articles-by-tag-section/ArticlesByTagSection"
import * as ArticleFrontPage from "../components/lib/blog/sections/article-front-page/ArticleFrontPage"
import * as ArticlesFrontPageLong from "../components/lib/blog/sections/article-front-page-long/ArticleFrontPageLong"
import * as FrontPageHeader from "../components/lib/blog/sections/front-page-header/FrontPageHeaderSection"
import * as TagsList from "../components/lib/blog/sections/tags-list-section/TagsListSection"
import * as ArticlesByCategorySection from "../components/lib/blog/sections/articles-by-category-section/ArticlesByCategorySection"
import * as VideoCardArticleList from "../components/lib/common/sections/video-card-articles-list/VideoCardArticlesList"
import * as MediaLogoSection from "../components/lib/common/sections/media-logo/MediaLogoSection"
import * as ContentBuilderSection from "../components/lib/common/sections/contentBuilder/ContentBuilderSection"
import * as Faq from "../components/lib/com/sections/faq-section/Faq"
import * as LatestCostumerReview from "../components/lib/com/sections/latest-costumer-review/LatestCostumerReview"
import * as CtxRhJobSectorTitleVideo from "../components/lib/rh/section/ctx-rh-job-sector-title-video/CtxRhJobSectorTitleVideo"
import * as RhTitreVideoSection from "../components/lib/rh/section/rh-titre-video/RhTitreVideoSection"
import * as ArticleViewer from "../components/lib/common/sections/article-viewer/ArticleViewerSection"
import * as HeroMedia from "../components/lib/common/sections/hero-media/HeroMediaSection"
import * as CtxProductCategory from "../components/lib/com/sections/ctx-product-category/CtxProductCategorySection"
import * as ContactForm from "../components/lib/common/sections/contact-form/ContactFormSection"
import * as RendezVousForm from "../components/lib/common/sections/rendez-vous-form/RendezVousFormSection"
import * as CandidatureForm from "../components/lib/common/sections/candidature-form/CandidatureFormSection"
import * as RhGlassdoorReviewSection from "../components/lib/rh/rh-glassdoor-review-section/RhGlassdoorReviewSection"
import * as ComTrustpilotReviewSection from "../components/lib/com/sections/com-trustpilot-review-section/ComTrustpilotReviewSection"
import * as BlogLastesArticlesSection from "../components/lib/blog/BlogLastesArticlesSection/BlogLastesArticlesSection"
import * as SearchResultSection from '../components/lib/common/sections/search-results/SearchResultsSection'
import * as CtxCitation from "../components/lib/rh/ctx-citation/CtxCitation"
import * as CardSwitch from "../components/lib/common/card-switch/CardSwitch"
import * as SearchAgency from "../components/lib/sl/sections/search-agency/SearchAgencySection"
import * as CtxEnteteAgence from "../components/lib/sl/sections/ctx-entete-agence/CtxEnteteAgenceSection"
import * as CtxDepartementAgences from "../components/lib/sl/sections/ctx-departement-agences/CtxDepartementAgencesSection"
import * as CtxRegionAgences from "../components/lib/sl/sections/ctx-region-agences/CtxRegionAgencesSection"
import * as ConversionForm from "../components/lib/common/sections/conversion-form/ConversionFormSection"
import * as OngletCartesSection from "../components/lib/common/sections/onglet-cartes/OngletCartesSection"
import * as CommuniquesDePresseParAnneeSection from "../components/lib/common/sections/communiques-de-pressea-par-annee/CommuniquesDePresseParAnneeSection.js"
import * as LastPressArticles from "../components/lib/common/sections/last-press-articles/LastPressArticles.js"
import * as ArticlesPresseParAnnee from "../components/lib/common/sections/articles-presse-par-annee/ArticlesPresseParAnnee.js"
import * as LastCommuniquesPressSlider from "../components/lib/common/sections/last-communiques-press-slider/LastCommuniquesPressSlider.js"

const libraryComponents = [
  TestComp1,
  TestComp2,
  RhHeaderHeroButtons,
  VideoPageCardSection,
  BigQuote,
  RhJobAdResultsSection,
  RhJobAdSearchFormSection,
  CtxArticleHeaderSection,
  CtxArticleViewerSection,
  CtxJobAdHeaderSection,
  CtxJobAdViewerSection,
  RhJobSectorMosaic,
  TitleTextButton,
  RhCtxAgencyPresentation,
  RhJobAdLastBannersSection,
  RhCtxAgencyHeroSection,
  RhCtxAgencyMosaic,
  CtxArticlesByTag,
  ArticleLeftRight,
  CtxJobSectorPersons,
  BlogArticlesSelectionBannerSection,
  BlogNewsletterSubscriptionSection,
  HeroHeaderTagsListSection,
  CtxRhJobSectorTitleVideo,
  ArticlesByTag,
  ArticleFrontPage,
  ArticlesFrontPageLong,
  FrontPageHeader,
  TagsList,
  ArticlesByCategorySection,
  VideoCardArticleList,
  MediaLogoSection,
  ContentBuilderSection,
  Faq,
  LatestCostumerReview,
  RhTitreVideoSection,
  ArticleViewer,
  HeroMedia,
  CtxProductCategory,
  ContactForm,
  RendezVousForm,
  CandidatureForm,
  RhGlassdoorReviewSection,
  ComTrustpilotReviewSection,
  BlogLastesArticlesSection,
  SearchResultSection,
  CtxCitation,
  CardSwitch,
  SearchAgency,
  CtxEnteteAgence,
  CtxDepartementAgences,
  CtxRegionAgences,
  ConversionForm,
  OngletCartesSection,
  CommuniquesDePresseParAnneeSection,
  LastPressArticles,
  ArticlesPresseParAnnee,
  LastCommuniquesPressSlider
]

const getComponent = (componentData, pageContext, location) => {
  const c = libraryGraphql.find(
    (i) => i.graphqlName === componentData.__typename
  )

  if (!c) {
    console.log(
      `WARN: Component not found in libraryGraphql : ${componentData.__typename}`
    )
    return null
  }

  const comp = libraryComponents.find((i) => i.name === c.name)

  if(!comp) {
    console.log("active comps : ", libraryComponents.map((i) => i.name))
    throw new Error(`Component not found in libraryComponents : ${c.name}`)
  }

  return comp.init(componentData, pageContext, location)
}

export const loadComponents = (componentsData, pageContext, location) => {
  const components = []
  for (const compData of componentsData) {
    components.push(getComponent(compData, pageContext, location))
  }

  return components
}

export default loadComponents
